import React from 'react';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router-dom';

toast.configure();
const StudentItem = ({ students }) => {
  let history = useHistory();

  function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const handleChecked = (e, key) => {
    const username = JSON.parse(localStorage.getItem('uname'));
    const URL = `https://stucharge.bakersbrisk.com/api/studentsapi?username=${username}&phone=${key}`;
    const AuthStr = process.env.REACT_APP_AUTH_STR;

    var value = false;
    if (e.target.checked) {
      value = true;
    }

    var bodyFormData = new FormData();
    bodyFormData.append('online_class_access', value);

    async function updatePost() {
      const requestOptions = {
        method: 'PUT',
        headers: { Authorization: AuthStr },
        body: bodyFormData,
      };
      fetch(URL, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          Swal.fire('Data updated successfully!', '', 'success').then(
            (result) => {
              if (result.isConfirmed || !result.isConfirmed) {
                history.push('/home');
                history.push('/students');
              }
            }
          );
        })
        .catch((error) => {
          toast.error('Error updating data');
          console.error('There was an error!', error);
        });
    }

    updatePost();
  };

  const changeUrl = (s) => {
    if (s[0] === '+') {
      return '%2B' + s.substring(1, s.length);
    }
    return s;
  };

  return (
    <>
      {students.map((item) => (
        <tr key={item.id}>
          <td data-label='Title'>{jsUcfirst(item.name)}</td>
          <td data-label='Phone'>{item.phone}</td>
          <td data-label='Email'>{item.email.substring(0, 8) + '...'}</td>
          <td data-label='Class Access'>
            <input
              type='checkbox'
              className='input-checkbox'
              title={`Click to allow or deny access`}
              checked={item.online_class_access}
              onClick={(e) => handleChecked(e, changeUrl(item.phone))}
              readOnly
            />
          </td>
          <td data-label='Enrolled Courses'>
            <a
              href={`/students/${changeUrl(item.phone)}`}
              className='bttn view'
              rel='noreferrer noopener'
            >
              View
            </a>
          </td>
        </tr>
      ))}
    </>
  );
};

export default StudentItem;
